import api from "./api";

/**
 * Apuracao por secao (/apuracao/boletim): importacao do boletim de urna do TSE
 * e consulta do fator cadastrados x votos. Somente perfis 1 e 2.
 */
class ApuracaoAPI {
  /** Candidatos (perfil 3) com chapa e ultima importacao. */
  async getCandidatos(headers) {
    return await api.get("/apuracao/candidatos", { headers });
  }

  /**
   * Envia o arquivo de votacao por secao (.zip ou .csv do TSE) do candidato.
   * O back valida o numero da chapa, grava a apuracao e recalcula o fator.
   */
  async importar(headers, equipe, arquivo) {
    const formData = new FormData();
    formData.append("equipe", equipe);
    formData.append("arquivo", arquivo);

    return await api.post("/apuracao/importar", formData, {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data"
      }
    });
  }

  /** Redistribui o fator com o cadastro atual (sem reimportar o arquivo). */
  async recalcular(headers, equipe) {
    return await api.post("/apuracao/recalcular", { equipe }, { headers });
  }

  /** @returns {Promise} { resumo: { candidato, importacao, totais }, zonas[], token } */
  async getResumo(headers, equipe) {
    return await api.get("/apuracao/resumo", { params: { equipe }, headers });
  }

  /** @returns {Promise} { secoes[], token } */
  async getSecoes(headers, equipe, zona) {
    return await api.get("/apuracao/secoes", { params: { equipe, zona }, headers });
  }
}

export default new ApuracaoAPI();
